export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              关于蘑菇视频
            </span>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
              蘑菇视频 — 您的高清视频伙伴
            </h1>
            <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
              <p>
                蘑菇视频成立于2018年，是国内领先的综合性高清视频平台。我们致力于为用户提供海量正版高清视频内容，涵盖<strong>电影</strong>、<strong>电视剧</strong>、<strong>综艺</strong>、<strong>动漫</strong>、<strong>纪录片</strong>等丰富品类，满足不同用户的多样化观影需求。
              </p>
              <p>
                作为<strong>蘑菇视频官网</strong>，我们始终坚持"内容为王、用户至上"的理念。平台累计上线超过5000部优质作品，日均活跃用户突破8000万，总播放量超过200亿次。我们与国内外200余家影视制作公司建立了深度合作关系，确保每一部作品都拥有正版授权。
              </p>
              <p>
                在技术创新方面，蘑菇视频官网率先支持<strong>4K超清画质</strong>和<strong>杜比全景声</strong>技术，通过AI智能推荐算法，为每位用户量身定制个性化内容推荐，让观影体验更加智能、便捷、沉浸。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-8 p-5 rounded-xl bg-background-100">
              <div className="text-center">
                <div className="text-xl font-bold text-primary-600">2018</div>
                <div className="text-xs text-foreground-500 mt-1">创立年份</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-600">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">正版内容</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-600">2亿+</div>
                <div className="text-xs text-foreground-500 mt-1">平台用户</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20office%20interior%2C%20large%20screens%20displaying%20cinematic%20content%2C%20creative%20workspace%20with%20warm%20lighting%2C%20contemporary%20tech%20company%20aesthetic%2C%20comfortable%20lounge%20area%2C%20orange%20and%20warm%20accent%20tones%2C%20professional%20yet%20inviting%20atmosphere&width=800&height=600&seq=about-brand-intro&orientation=landscape"
                alt="蘑菇视频品牌介绍"
                title="蘑菇视频官网 - 品牌介绍"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}